class StorageService {
    constructor($localStorage, $sessionStorage, $cookies, config) {
        this._$localStorage = $localStorage;
        this._$sessionStorage = $sessionStorage;
        this._$cookies = $cookies;
        this.config = config;

    }

    setToken(token) {
        if (angular.isDefined(token)) {
            this._$sessionStorage.token = token;
            return true;
        } else {
            this._$sessionStorage.token = null;
            return false;
        }
    }

    getToken() {
        if (this._$sessionStorage.token) {
            return this._$sessionStorage.token.accessToken;

        } else { return false; }
    }

    getAllTokens() {
        if (this._$sessionStorage.token) {
            return this._$sessionStorage.token;

        } else { return false; }
    }

    setManagerHostname(hostname) {
        this._$sessionStorage.managerHostname = hostname;
    }

    getManagerHostname() {
        return this._$sessionStorage.managerHostname;
    }

    setUsername(username) {
        this._$sessionStorage.username = username;
    }

    getUsername() {
        return this._$sessionStorage.username;
    }

    setUser(user) {
        this._$sessionStorage.user = angular.isDefined(user) ? {
            username: user.username,
            name: user.name,
            email: user.email,
            role: user.role,
            status: user.status,
            uuid: user.uuid
        } : undefined;
    }

    getUser() {
        return this._$sessionStorage.user;
    }

    setUserUuid(uuid) {
        this._$sessionStorage.userUUID = uuid;
    }

    getUserType() {
        return this._$sessionStorage.userType;
    }

    setUserType(type) {
        this._$sessionStorage.userType = type;
    }

    getUserUuid() {
        return this._$sessionStorage.userUUID;
    }

    onLogout() {
        this.deleteSubscription(undefined);
        this.setToken(undefined);
        this.setUser(undefined);
        this.setUsername(undefined);
        this.setUserUuid(undefined);
        this.setUserType(undefined);
    }

    getGridWolumnsWidthMapInPct(tableName) {
        let localKeys = Object.keys(this._$localStorage);
        for (let i = 0; i < localKeys.length; i++) {
            if (localKeys[i].indexOf('-grid-') > -1) {
                //go through all grid in local storage
                let tempVer = localKeys[i].split('version-')[1];
                if (tempVer !== this.config.appVersion) {
                    //remove all grid that does not match with current version
                    this._$localStorage[localKeys[i]] = undefined;
                }
            }
        }
        const tableGridId = tableName + '-version-' + this.config.appVersion;
        return this._$localStorage[tableGridId];
    }

    getSubscription() {
        let subscription = this._$localStorage['currentSubscription-' + this.getUsername()];
        if (subscription) {
            subscription = JSON.parse(subscription);
        }

        return subscription;
    }

    setSubscription(currentSubscription) {
        this._$localStorage['currentSubscription-' + this.getUsername()] = JSON.stringify(currentSubscription);
        this.setTempsubscriptionId(currentSubscription.uuid);
    }

    setProtectionSet(currentProtectionSet) {
        this._$localStorage['selectedProtectionSet'] = JSON.stringify(currentProtectionSet);
    }

    getProtectionSet() {
        let protectionSet = this._$localStorage['selectedProtectionSet'];
        if (protectionSet) {
            protectionSet = JSON.parse(protectionSet);
        }
        return protectionSet;
    }

    deleteSubscription() {
        this._$localStorage['currentSubscription-' + this.getUsername()] = undefined;
    }

    setTempsubscriptionId(subscriptionId) {
        this.tempSubscriptionId = subscriptionId;
    }

    getTempSubscriptionId() {
        let temp = this.tempSubscriptionId;
        this.tempSubscriptionId = null;
        return temp;
    }

    setCompactNavigation(isCompact) {
        this._$localStorage['compactNavigation-' + this.getUsername()] = isCompact;
    }

    getCompactNavigation() {
        let compact = this._$localStorage['compactNavigation-' + this.getUsername()];
        return compact;
    }

    setCustomPageSize(name, pageSize) {
        this._$sessionStorage['temp_ps_' + name] = pageSize;
    }

    getCustomPageSize(name) {
        return this._$sessionStorage['temp_ps_' + name];
    }

    clearCustomPageSize(name) {
        this._$sessionStorage['temp_ps_' + name] = undefined;
    }

    getLang() {
        return this._$sessionStorage.lang;
    }
    setLang(lang) {
        return this._$sessionStorage.lang = lang;
    }

    setPermissions(permissions) {
        this._$sessionStorage.permissions = permissions;
    }

    getPermissions() {
        return this._$sessionStorage.permissions;
    }

    setTempPermissions(permissions) {
        this._$sessionStorage.tempPermissions = permissions;
    }

    getTempPermissions() {
        return this._$sessionStorage.tempPermissions;
    }

}
StorageService.$inject = ['$localStorage', '$sessionStorage', '$cookies', 'config'];

module.exports = StorageService;



// WEBPACK FOOTER //
// ./src/azurebackup/services/storage.service.js